// extracted by mini-css-extract-plugin
export var copyrightGraf = "copyright-module--copyrightGraf--6c56a";